import {Vec2} from "./math/vec2";
import {Rect} from "./math/rect";
import {CELL_SIZE, ClientDiagram} from "./types";

/**
 * Calculate the bounding box of all elements in the diagram
 */
export function calculateDiagramBounds(diagram: ClientDiagram, padding: number = 2): Rect {
  let rect = Rect.empty();

  // Process all items:

  for (const node of diagram.nodes.values()) {
    rect = rect.unionPoint(new Vec2(node.position.x, node.position.y));
  }

  for (const connection of diagram.connections.values()) {
    const startNode = diagram.nodes.get(connection.from)!;
    const endNode = diagram.nodes.get(connection.to)!;

    rect = rect.unionPoint(startNode.position);
    rect = rect.unionPoint(endNode.position);

    // Process all anchor positions
    for (const anchor of connection.anchors) {
      rect = rect.unionPoint(anchor.position);
    }
  }

  // ------------------------

  if (rect.isEmpty()) {
    // Just generate a reasonably sized empty diagram.
    const size = new Vec2(CELL_SIZE * 4, CELL_SIZE * 4);
    return Rect.fromMinSize(new Vec2(-padding, -padding), size.addScalar(padding * 2));
  }

  rect.max = rect.max.addScalar(1);
  return rect.expand(padding).scale(CELL_SIZE);
}
